const BaseOptions = {
  accessoriesType: [
    'Blank',
    'Kurt',
    'Prescription01',
    'Prescription02',
    'Round',
    'Sunglasses',
    'Wayfarers',
  ],
  hatColor: [
    'Black',
    'Blue01',
    'Blue02',
    'Blue03',
    'Gray01',
    'Gray02',
    'Heather',
    'PastelBlue',
    'PastelGreen',
    'PastelOrange',
    'PastelRed',
    'PastelYellow',
    'Pink',
    'Red',
    'White',
  ],
  hairColor: [
    'Auburn',
    'Black',
    'Blonde',
    'BlondeGolden',
    'Brown',
    'BrownDark',
    'PastelPink',
    'Platinum',
    'Red',
    'SilverGray',
  ],
  clotheType: [
    'BlazerShirt',
    'BlazerSweater',
    'CollarSweater',
    'GraphicShirt',
    'Hoodie',
    'Overall',
    'ShirtCrewNeck',
    'ShirtScoopNeck',
    'ShirtVNeck',
  ],
  clotheColor: [
    'Black',
    'Blue01',
    'Blue02',
    'Blue03',
    'Gray01',
    'Gray02',
    'Heather',
    'PastelBlue',
    'PastelGreen',
    'PastelOrange',
    'PastelRed',
    'PastelYellow',
    'Pink',
    'Red',
    'White',
  ],
  graphicType: [
    'Bat',
    'Cumbia',
    'Deer',
    'Diamond',
    'Hola',
    'Pizza',
    'Resist',
    'Selena',
    'Bear',
    'SkullOutline',
    'Skull',
  ],
  eyeType: [
    'Close',
    'Default',
    'Dizzy',
    'EyeRoll',
    'Happy',
    'Hearts',
    'Side',
    'Squint',
    'Surprised',
    'Wink',
    'WinkWacky',
  ],
  eyebrowType: [
    'Default',
    'DefaultNatural',
    'FlatNatural',
    'RaisedExcited',
    'RaisedExcitedNatural',
    'UnibrowNatural',
    'UpDown',
    'UpDownNatural',
  ],
  mouthType: [
    'Default',
    'Disbelief',
    'Eating',
    'Grimace',
    'Serious',
    'Smile',
    'Tongue',
    'Twinkle',
  ],
  skinColor: [
    'Tanned',
    'Yellow',
    'Pale',
    'Light',
    'Brown',
    'DarkBrown',
    'Black',
  ],
  facialHairType: ['Blank'],
  facialHairColor: ['Black'],
};

const MaleOptions = {
  topType: [
    'NoHair',
    'Eyepatch',
    'Hat',
    'Turban',
    'WinterHat1',
    'WinterHat2',
    'WinterHat3',
    'WinterHat4',
    'ShortHairDreads01',
    'ShortHairDreads02',
    'ShortHairFrizzle',
    'ShortHairShaggyMullet',
    'ShortHairShortCurly',
    'ShortHairShortFlat',
    'ShortHairShortRound',
    'ShortHairShortWaved',
    'ShortHairSides',
    'ShortHairTheCaesar',
    'ShortHairTheCaesarSidePart',
  ],
  facialHairType: [
    'Blank',
    'BeardMedium',
    'BeardLight',
    'BeardMajestic',
    'MoustacheFancy',
    'MoustacheMagnum',
  ],
  facialHairColor: [
    'Auburn',
    'Black',
    'Blonde',
    'BlondeGolden',
    'Brown',
    'BrownDark',
    'Platinum',
    'Red',
  ],
};

const FemaleOptions = {
  topType: [
    'Hat',
    'Hijab',
    'WinterHat1',
    'WinterHat2',
    'WinterHat3',
    'WinterHat4',
    'LongHairBigHair',
    'LongHairBob',
    'LongHairBun',
    'LongHairCurly',
    'LongHairCurvy',
    'LongHairDreads',
    'LongHairFrida',
    'LongHairFro',
    'LongHairFroBand',
    'LongHairNotTooLong',
    'LongHairShavedSides',
    'LongHairMiaWallace',
    'LongHairStraight',
    'LongHairStraight2',
    'LongHairStraightStrand',
  ],
};

const selectRandom = (arr: String[]) => {
  return arr[Math.floor(Math.random() * arr.length)];
};

export const getRandomOptions = (isMale = false) => {
  let options = { ...BaseOptions, ...FemaleOptions };

  if (isMale) {
    options = { ...BaseOptions, ...MaleOptions };
  }

  return {
    avatarStyle: 'transparent',
    topType: selectRandom(options.topType) as string,
    accessoriesType: selectRandom(options.accessoriesType) as string,
    hatColor: selectRandom(options.hatColor) as string,
    hairColor: selectRandom(options.hairColor) as string,
    facialHairType: selectRandom(options.facialHairType) as string,
    facialHairColor: selectRandom(options.facialHairColor) as string,
    clotheType: selectRandom(options.clotheType) as string,
    clotheColor: selectRandom(options.clotheColor) as string,
    graphicType: selectRandom(options.graphicType) as string,
    eyeType: selectRandom(options.eyeType) as string,
    eyebrowType: selectRandom(options.eyebrowType) as string,
    mouthType: selectRandom(options.mouthType) as string,
    skinColor: selectRandom(options.skinColor) as string,
  };
};

export default getRandomOptions;
